"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerkleProof = void 0;
const validation_1 = require("../../validation");
/**
 * Merkle Proof
 * @alpha
 */
var MerkleProof;
(function (MerkleProof) {
    MerkleProof.schema = {
        type: 'object',
        properties: {
            proof: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            index: {
                type: 'number'
            },
            hashingKeys: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            entityHash: {
                type: 'string'
            }
        },
        required: ['entityHash', 'hashingKeys', 'index', 'proof'],
        additionalProperties: false
    };
    MerkleProof.validate = (0, validation_1.generateValidator)(MerkleProof.schema);
})(MerkleProof = exports.MerkleProof || (exports.MerkleProof = {}));
//# sourceMappingURL=merkle-proof.js.map